export const StandardVatRateId = "117035d6-c31f-4600-9ec6-b26eb76d080a";
export const ZeroRateVatId = "f3d99f2e-2387-47a8-921a-ae9099f6502f";
